import { useEffect, useState } from "react";

const BASE_URL = "https://portales.utpl.edu.ec/beportales";

const DataFetcher = ({ url, children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 🔥 Obtener UNA imagen
  const getImageUrl = (node, included, fieldName) => {
    const mediaId = node.relationships?.[fieldName]?.data?.id;
    if (!mediaId) return null;

    const media = included.find(
      (item) => item.type === "media--image" && item.id === mediaId,
    );

    const fileId = media?.relationships?.field_media_image?.data?.id;
    if (!fileId) return null;

    const file = included.find(
      (item) => item.type === "file--file" && item.id === fileId,
    );

    return file?.attributes?.uri?.url
      ? BASE_URL + file.attributes.uri.url
      : null;
  };

  // 🔥 Obtener MUCHAS imágenes
  const getImageUrls = (node, included, fieldName) => {
    const mediaItems = node.relationships?.[fieldName]?.data;

    if (!Array.isArray(mediaItems)) return [];

    return mediaItems
      .map((item) => {
        const media = included.find(
          (inc) => inc.type === "media--image" && inc.id === item.id,
        );

        const fileId = media?.relationships?.field_media_image?.data?.id;

        const file = included.find(
          (inc) => inc.type === "file--file" && inc.id === fileId,
        );

        return file?.attributes?.uri?.url
          ? BASE_URL + file.attributes.uri.url
          : null;
      })
      .filter(Boolean);
  };

  // 🔥 Obtener DOCUMENTO
  const getDocumentUrl = (node, included, fieldName) => {
    const mediaId = node.relationships?.[fieldName]?.data?.id;

    if (!mediaId) return null;

    // buscar media document
    const media = included.find(
      (item) => item.type === "media--document" && item.id === mediaId,
    );

    // obtener file id
    const fileId = media?.relationships?.field_media_document?.data?.id;

    if (!fileId) return null;

    // buscar archivo
    const file = included.find(
      (item) => item.type === "file--file" && item.id === fileId,
    );

    return file?.attributes?.uri?.url
      ? BASE_URL + file.attributes.uri.url
      : null;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!url) throw new Error("URL no proporcionada");

        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`Error ${response.status}`);
        }

        const json = await response.json();

        console.log("API RESPONSE:", json);

        const node = Array.isArray(json?.data) ? json.data[0] : json.data;

        const atributos = node?.attributes;
        const included = json?.included || [];

        if (!atributos) {
          throw new Error("Estructura inesperada de la API");
        }

        // 🔥 AUTOMATIZAR BLOQUES
        const bloques = {};

        for (let i = 1; i <= 30; i++) {
          bloques[`bloque${i}`] =
            atributos[`field_bloque${i}`]?.processed || "";
        }

        // 🔥 AUTOMATIZAR IMÁGENES
        const imagenes = {};

        for (let i = 1; i <= 30; i++) {
          imagenes[`imagen${i}`] =
            getImageUrl(node, included, `field_imagen${i}`) || "";
        }

        // 🔥 Imagen portada
        const imagen_portada =
          getImageUrl(node, included, "field_imagen_portada") || "";

        const cleanData = {
          id: node.id,
          titulo: atributos.title,

          texto_portada: atributos.field_texto_portada?.processed || "",

          imagen_portada,

          // ✅ bloques automáticos
          ...bloques,

          // ✅ imágenes automáticas
          ...imagenes,

          // ✅ galería
          galeria: getImageUrls(node, included, "field_gallery"),
          documento1: getDocumentUrl(node, included, "field_documento_1"),
          documento2: getDocumentUrl(node, included, "field_documento_2"),
        };

        setData(cleanData);
      } catch (err) {
        console.error("FETCH ERROR:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url]);

  if (loading) return <p>Cargando...</p>;

  if (error) return <p>Error: {error}</p>;

  return children(data);
};

export default DataFetcher;
